import React from 'react';
import ReactDOM from 'react-dom';
import { StateProvider } from './StateProvider';
import reducer, { initialState } from './reducer';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles'; // ✅ for makeStyles
import {
  ThemeProvider as MaterialThemeProvider,
} from '@mui/material/styles';

import App from './App';
import theme from './styles/theme';


ReactDOM.render(
  <React.StrictMode>
    <MaterialThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
        <StateProvider initialState={initialState} reducer={reducer}>
          <App />
        </StateProvider>
      </StylesThemeProvider>
    </MaterialThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
